import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { FileSummary } from "@apaq/orgkit-js";
import { Download } from "src/app/net/download";

@Component({
  selector: 'app-file-preview',
  template: `<sl-dropdown #dropdown disabled (mouseover)="onMouseOver()" (mouseout)="onMouseOut()" placement="top" hoist>
      <span slot="trigger">
        <ng-content></ng-content>
      </span>
      <div class="container">
        <img class="preview" *ngIf="isImage()" [src]="file?.url">
      </div>
    </sl-dropdown>`,
    styles: [
      '.container {max-width:400px;width:400px}',
      '.preview {object-fit:cover; width:100%;height:100%;}'
    ]
})
export class FilePreviewComponent {

  @ViewChild('dropdown') dropdown?: ElementRef;
  @Input() file?: FileSummary;
  
  isImage() {
    if(this.file == null) return false;
    const index = this.file.name.lastIndexOf('.');
    if(index < 0 || index >= this.file.name.length-1) {
      return false;
    }

    const suffix = this.file.name.substring(this.file.name.lastIndexOf('.') + 1).toLowerCase()
    return ['png', 'jpg', 'gif', 'jpeg', 'tif', 'bmp', 'apng', 'avif', 'webp', 'svg'].indexOf(suffix) >= 0;
  }

  onMouseOver() {
    if(this.isImage()) {
      this.dropdown?.nativeElement.show();
    }
  }

  onMouseOut() {
    this.dropdown?.nativeElement.hide();
  }
}